import { useEffect, useState, useMemo } from 'react';
import { Animate } from 'react-simple-animate';

interface SideDrawerProps {
  show: boolean;
  children: React.ReactNode;
}

const useLayoutHook = () => {
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const SideDrawer = useMemo(() => {
    const SideDrawerComponent = ({ show, children }: SideDrawerProps) => {
      const endStyles = {
        zIndex: 2147483647,
        position: 'absolute' as 'absolute',
        top: 0,
        right: screenWidth > 550 ? 0 : '20px',
        width: screenWidth > 550 ? '550px' : '100vw',
        maxHeight: 'calc(100vh - 105px)'
      };

      const startStyles = {
        zIndex: 2147483647,
        position: 'absolute' as 'absolute',
        top: 0,
        right: screenWidth > 550 ? '-550px' : '-100vw',
        width: screenWidth > 550 ? '550px' : '100vw'
      };

      return (
        <Animate play={show} start={startStyles} end={endStyles}>
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40 transition-opacity duration-300 "
            />

            {children}
          </>
        </Animate>
      );
    };

    SideDrawerComponent.displayName = 'SideDrawer';
    return SideDrawerComponent;
  }, [screenWidth]);

  const isMobile = screenWidth < 768;
  const isTablet = screenWidth >= 768 && screenWidth < 1024;
  const isDesktop = screenWidth >= 1024;
  return { screenWidth, SideDrawer, isMobile, isTablet, isDesktop };
};

export default useLayoutHook;
